import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const KEY = "vdi_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      try {
        if (new URLSearchParams(window.location.search).has("codice")) return;
        if (!localStorage.getItem(KEY)) setVisible(true);
      } catch {
        setVisible(true);
      }
    }, 900);
    return () => clearTimeout(t);
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(
        KEY,
        JSON.stringify({ choice, ts: new Date().toISOString() })
      );
    } catch {}
    setVisible(false);
    window.dispatchEvent(new Event("vdi-cookie-decided"));
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-6 md:left-auto md:right-6 md:max-w-md z-[60]"
          data-testid="cookie-banner"
        >
          <div className="bg-[#0A0A0A] text-[#F2EFE8] border border-[#1f1f1f] shadow-2xl">
            <div className="p-6 sm:p-7">
              <div className="flex items-center gap-3 mb-4">
                <span className="overline text-[10px] text-[#C4A671]">
                  Privacy &amp; Cookie
                </span>
                <span className="text-[#C4A671]">✦</span>
              </div>
              <h3 className="font-serif-display text-2xl leading-tight mb-3">
                Rispettiamo la tua privacy.
              </h3>
              <p className="text-[14px] leading-relaxed text-[#C9C3B5] font-light">
                Questo sito utilizza cookie tecnici essenziali per il
                funzionamento. Non utilizziamo cookie di profilazione. Per
                maggiori informazioni consulta la nostra{" "}
                <Link
                  to="/cookie-policy"
                  className="underline text-[#E7E2D5] hover:text-[#C4A671] transition"
                  data-testid="cookie-banner-policy-link"
                >
                  Cookie Policy
                </Link>
                .
              </p>
              <div className="mt-6 flex items-center gap-4">
                <button
                  onClick={() => decide("accepted")}
                  data-testid="cookie-accept-btn"
                  className="inline-flex items-center gap-2 bg-[#FDFBF7] text-[#0A0A0A] px-5 py-3 text-[10.5px] font-medium tracking-[0.24em] uppercase hover:bg-[#C4A671] hover:text-[#0A0A0A] transition"
                >
                  Accetta
                </button>
                <button
                  onClick={() => decide("rejected")}
                  data-testid="cookie-reject-btn"
                  className="text-[10.5px] font-medium tracking-[0.24em] uppercase text-[#C9C3B5] hover:text-white transition border-b border-[#3a3a3a] pb-1"
                >
                  Solo essenziali
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
